"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = Radio;
var _lib = require("@a1s/lib");
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // @flow
function Radio({
  checked = false,
  css: cssProps,
  testId = 'base-radio',
  id = `id${(0, _lib.random)()}`,
  label,
  onChange,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_styled.Input, _extends({
    checked: checked,
    id: id,
    type: "radio",
    onChange: onChange
  }, props)), /*#__PURE__*/_react.default.createElement(_styled.Label, {
    css: cssProps,
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement(_styled.TitleText, null, label)));
}